// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const commonHeaderWrapper = "CommonHeaderMobile__commonHeaderWrapper__hIpYt font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const moneyflow = "CommonHeaderMobile__moneyflow__IZYaD";
export const debts = "CommonHeaderMobile__debts__wKbXx";
export const assets = "CommonHeaderMobile__assets__gue1n";
export const credit = "CommonHeaderMobile__credit__hNXZG";
export const redemptions = "CommonHeaderMobile__redemptions__SOJId";
export const columnsPrefix = "CommonHeaderMobile__columnsPrefix__vcqJd";
export const columnNamesWrapper = "CommonHeaderMobile__columnNamesWrapper__vBJt7";
export const columnNameWrapper = "CommonHeaderMobile__columnNameWrapper__j0ZfM";
export const columnName = "CommonHeaderMobile__columnName__Wn91G";
export const sortingWrapper = "CommonHeaderMobile__sortingWrapper__M3K3g";
export const up = "CommonHeaderMobile__up__qcd8x";
export const down = "CommonHeaderMobile__down__+z3gq";